import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import React from 'react';

const TheContextSecondariesBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Secondaries 3.0 in India: There are decades where nothing happens
            and there are weeks where decades happen
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Norbert Fernandes, General Partner, Kenro Capital
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Norbert Fernandes',
              position: 'General Partner, Kenro Capital',
              image:
                'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-05at64706PM-pKkMsluLKa38X.png',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>

        <Flex flexDirection="column" w="100%">
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              A primer on private equity secondaries
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Private Equity (PE) and Venture Capital (VC) are both
              well-understood assets classes in Asia. Between these 2
              strategies, fund managers (GPs) in India have raised and deployed
              USD 400+ bn over the last 15 years, and have been responsible for
              identifying and funding several disruptive businesses in India, of
              which a handful have even gone on to IPO. PE/VC funds commonly are
              closed-ended with a fund life of 7 to 10 years, within which they
              are expected to exit all their investments are return money to
              their investors (LPs). However, historically, it has taken longer
              than this, on average, to scale a portfolio company to full
              potential, especially in India. This creates all sorts of issues
              for GPs, including a common paradoxical situation of strong NAVs
              (Net Asset Value – the value of assets “on paper”) yet low DPI
              (Distributed-to-Paid-In capital ratio – a key measure of “cash on
              cash” returns to LPs). As the PE/VC ecosystem matures, LPs have
              now started paying close attention to the DPI metric. The PE/VC
              equivalent of the popular eCommerce aphorism “GMV is vanity,
              Profit is sanity, but Cash is King” is:
            </Text>

            <Text
              variant="blogAnswer"
              mt="16px"
              fontStyle="italic"
              fontWeight="600"
              color="primary.500"
            >
              "NAV is vanity, IRR is sanity, but DPI is king"
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Globally, secondaries have been a critical mechanism for GPs to
              achieve timely DPI on investments in a structured and fair way.{' '}
              <strong>
                Secondary funds essentially buy stakes in companies from GPs
                ensuring a full or partial exit for their investment
              </strong>
              . In a way, they carry forward the baton from earlier investors
              (much like in a relay race), towards an eventual full exit (IPO /
              strategic sale / buyout).
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Global history of secondary funds
            </Text>

            <Text variant="blogAnswer" mt="16px">
              In developed markets like the US and Europe, secondary funds are a
              large and well-documented asset class for several decades now.
            </Text>

            <Img
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-06-05at70701PM-GLUYtccZbbtDR.png"
              alt="secondary-funds"
              objectFit="contain"
              mt="16px"
            />
            <Text variant="blogAnswer" mt="16px">
              The top 10 secondary fund managers globally manage a collective
              ~$300b in capital. This is comparable to the total PE/VC capital{' '}
              <strong>ever</strong> invested in India. The five largest
              secondary funds raised till date were all raised after 2021, and
              total to &gt;$50b. While these funds are typically less spoken and
              written about, the sheer numbers alone should give you a good
              sense of how scaled up and systemically important this asset class
              has become in developed markets.
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Secondaries in India: A mathematical inevitability?
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Secondaries become large and relevant in a market only after a
              critical mass of PE/VC funds have been deployed and are starting
              to reach the end of their fund lives. Before this critical mass is
              hit, secondaries funds can sometimes look like a "solution in
              search of a problem". But after it happens, they very quickly
              become a vital conduit in the capital flow machinery. Timely
              capital return to LPs is an increasingly important reason why
              investors come back to invest in next funds. Now, with adequate
              maturity in the market, this is also measurable and comparable
              across funds. Mature GPs understand this trade-off between
              generating DPI today vs incremental future MOIC, and work closely
              with secondary funds to optimize between these two competing
              objectives.{' '}
              <strong>
                How a GP manages this trade-off is, in our view, going to be THE
                key defining quality of "sought-after" GPs in India in the
                coming decade.
              </strong>
            </Text>
            <Img
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-06-05at70907PM-rSCESlH6QQVUF.png"
              alt="secondary-funds"
              objectFit="contain"
              my="16px"
            />
            <Text variant="blogAnswer" fontSize="14px" mt="16px">
              <strong>Source:</strong>
              <Link
                href="https://www.pinebridge.com/en/insights/could-the-private-equity-secondary-market-triple-in-5-years"
                target="_blank"
                color="blue.500"
                textDecoration="underline"
              >
                https://www.pinebridge.com/en/insights/could-the-private-equity-secondary-market-triple-in-5-years
              </Link>
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Maturing of the market
            </Text>

            <Text variant="blogAnswer" mt="16px">
              We firmly believe India and SE Asia have now hit critical mass in
              terms of number of high-quality entrepreneurs, scaled late-stage
              companies funded by PE/VCs, and also in terms of number of funds
              that are nearing end of life and, therefore, could benefit from
              well thought out secondary solutions. As early practitioners in
              this market as a team, we have not only seen the market evolve
              from its nascency, but we've ourselves have played our part in
              building this market from first principles. And with it, our
              conviction has only grown. We believe the secondary market in Asia
              which earlier somewhat monolithic, with few "one size fits all"
              funds, will become increasingly sophisticated, and open up
              opportunities for multiple specialized strategies to deliver
              liquidity to GPs.
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Types of Secondary solutions and evolution of the market in India
            </Text>

            <Text variant="blogAnswer" mt="16px" mb="16px">
              The 2 key features that define and differentiate a secondary
              strategy is its philosophy towards <br /> a) directs vs
              portfolios, and <br /> b) quality vs discounts. With this in mind,
              we share our view of how the industry has evolved, and where it is
              headed:
            </Text>

            <Box
              overflowX="auto"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="8px"
              mb="16px"
            >
              <Box as="table" w="100%" minW="600px">
                <Box as="thead" bg="gray.50">
                  <Box as="tr">
                    <Box
                      as="th"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="bold"
                    >
                      Feature
                    </Box>
                    <Box
                      as="th"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="bold"
                    >
                      Secondaries 1.0 (2010-)
                    </Box>
                    <Box
                      as="th"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="bold"
                    >
                      Secondaries 2.0 (2016-)
                    </Box>
                    <Box as="th" p="12px" fontWeight="bold">
                      Secondaries 3.0 (2024-)
                    </Box>
                  </Box>
                </Box>
                <Box as="tbody">
                  <Box as="tr" borderBottom="1px solid" borderColor="gray.200">
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="600"
                    >
                      Seller Type
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      LPs in funds
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Fund GPs
                    </Box>
                    <Box as="td" p="12px">
                      Fund GPs
                    </Box>
                  </Box>
                  <Box as="tr" borderBottom="1px solid" borderColor="gray.200">
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="600"
                    >
                      Type of Sale
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      LP fund stakes, typically within a basket of several other
                      fund commits
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Mainly portfolios, with some single asset directs
                    </Box>
                    <Box as="td" p="12px">
                      Increasingly more single asset directs / portfolio
                      carveouts
                    </Box>
                  </Box>
                  <Box as="tr" borderBottom="1px solid" borderColor="gray.200">
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="600"
                    >
                      Access to portfolio
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Negligible
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Strong set of portfolio information
                    </Box>
                    <Box as="td" p="12px">
                      Full, primary-like access
                    </Box>
                  </Box>
                  <Box as="tr" borderBottom="1px solid" borderColor="gray.200">
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="600"
                    >
                      Ability to select assets
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Negligible
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Limited
                    </Box>
                    <Box as="td" p="12px">
                      High
                    </Box>
                  </Box>
                  <Box as="tr">
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                      fontWeight="600"
                    >
                      Pricing
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      High discount to NAV
                    </Box>
                    <Box
                      as="td"
                      p="12px"
                      borderRight="1px solid"
                      borderColor="gray.200"
                    >
                      Low-mid discount to NAV
                    </Box>
                    <Box as="td" p="12px">
                      Bottom-up valuation based on full info
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Text variant="blogAnswer" mt="16px" fontWeight="600">
              In short, secondary transactions are going to get "closer to the
              asset", with deeper access to information and management. In sync
              with this, "on the ground" fund managers who have deep networks
              with GPs and founders, and who have the capability to navigate
              complex multi-party transactions and structures, will increasingly
              emerge and take a lead in this space.
            </Text>

            <Text variant="blogAnswer" mt="16px">
              We are confident all 3 models will continue to evolve and will
              co-exist in India. GP liquidity needs come in all forms, and every
              kind of solution will find its application.
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Our preferred approach to secondaries
            </Text>

            <Text variant="blogAnswer" mt="16px" fontStyle="italic">
              "When we back-test the performance of our funds, most indicative
              of the return is not what we pay, but what we buy"
              <br />
              <Text as="span" fontSize="14px" color="gray.600">
                - Wilfred Small, Senior Managing Director, Ardian
              </Text>
            </Text>

            <Text variant="blogAnswer" mt="16px">
              <strong>Our philosophy on secondaries is simple</strong>: <br />{' '}
              a) bias for quality, <br /> b) invest only in situations where we
              have deep access, <br /> c) be the founder's go-to team for all
              things corporate finance (IPO, M&A), and <br /> d) efficient
              transaction execution. Along the way, we will evolve with the
              market as much as co-create it.
            </Text>
          </Box>

          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Conclusion
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Our mission is clear: the Indian PE/VC industry, in general, does
              not face a “value creation” problem, but does face a “cash flow
              mismatch” problem. We are building out the Kenro platform, brick
              by brick, to play a leading role in solving this mismatch.
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextSecondariesBlog;
